import React from 'react';
import cn from 'classname';

import Cell from './cell';

const Row = props => {

	const { row, intervals } = props;

	const expanded_from_id = row.expanded_from_id;

	return (
		<tr className={cn({'narrow-row': !!expanded_from_id})}>
			<td
				className={cn({
					'fixed-col min-width-100 max-width-100': true,
					'padding-left-20': true
				})}>
				<span>
					{ row.created_month} Affs: ({!!row.affiliate_ids && row.affiliate_ids.length})
				</span>
			</td>
			{intervals.map((int, index) => <Cell key={index} row={row} interval={int} />)}
		</tr>
	);
};

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/registration-activity/components/row-month.js